
import { SnackbarProvider } from "notistack";
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
import { BaseOptionChartStyle } from "./components/chart/BaseOptionChart";
import ScrollToTop from "./components/ScrollToTop";
import { GlobalStateProvider } from './globalHooks/GlobalState'
import { BUProvider } from "./context/BuContext/BuContext";
// ----------------------------------------------------------------------

export default function App() {
  return (
    <GlobalStateProvider>
      <BUProvider>
        <ThemeProvider>

          <SnackbarProvider maxSnack={3}>
            <ScrollToTop />
            <BaseOptionChartStyle />
            <Router />
          </SnackbarProvider>

        </ThemeProvider>
      </BUProvider>
    </GlobalStateProvider>
  );
}
